<template>
  <div class="course-report" v-if="courseDetail">
    <div class="chart-ul" v-if="charts.length > 0">
      <div class="chart-li" v-for="(item, index) in charts" :key="`${item.type}_${index}`">
        <div class="chart-item" :id="`chart_${index}`">
          <component
            v-if="item.type === 'tableAnalysisChart'"
            :is="item.type"
            :ref="`${item.type}_${index}`"
            byDashboard
          />
          <component
            v-else
            :is="item.type"
            :rows="item.rows"
            :statistics="item.statistics"
            :ref="`${item.type}_${index}`"
            byDashboard
            customLegend
            :chartHeight="540"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pieChart from '@/components/chartComponents/pieChart';
import pieChart2 from '@/components/chartComponents/pieChart2';
import barChart from '@/components/chartComponents/barChart';
import barXChart from '@/components/chartComponents/barXChart';
import lineChart from '@/components/chartComponents/lineChart';
import lineChart2 from '@/components/chartComponents/lineChart2';
import numChart from '@/components/chartComponents/numChart';
import tableChart from '@/components/chartComponents/tableChart';
import tableAnalysisChart from '@/components/chartComponents/tableAnalysisChart';
import { checkChartInfo } from '@/lib/utils';

import { services } from '@/service';
import { computed } from 'vue';
export default {
  components: {
    pieChart,
    pieChart2,
    barChart,
    barXChart,
    lineChart,
    lineChart2,
    numChart,
    tableChart,
    tableAnalysisChart
  },
  data() {
    return {
      totalCount: 0,
      courseDetail: null,
      paragraphArr: [],
      courseUnitGroups: []
    };
  },
  provide() {
    return {
      courseUnitGroups: computed(() => this.courseUnitGroups)
    };
  },
  computed: {
    courseId() {
      return this.$route.query.courseware_id;
    },
    charts() {
      if (!this.courseDetail) {
        return [];
      }
      return this.courseDetail._source.chart;
    }
  },
  async mounted() {
    const [courseDetail, courseUnitGroups] = await Promise.all([
      services.courseware.getCoursewareDetail(this.courseId),
      services.courseware.getCourseUnitGroups(this.courseId)
    ]);
    this.courseDetail = courseDetail;
    this.courseUnitGroups = courseUnitGroups;
    await this.$nextTick();
    this.charts.forEach((chartItem, index) => {
      const componData = checkChartInfo({
        colors: chartItem.colors,
        chartConfig: chartItem.chartConfig,
        rows: chartItem.rows,
        columns: chartItem.columns,
        statistics: chartItem.statistics,
        researchCondition: chartItem.conditionTemp,
        courseCondition: this.courseDetail._source.conditionTemp,
        courseId: this.courseDetail._id,
        originData: JSON.parse(chartItem.dataSet || '{}'),
        sortStatistic: JSON.parse(chartItem.sortStatistic || '{}'),
        relationFilterVal: chartItem.relationFilterVal,
        relationFilterName: chartItem.relationFilterName
      });
      const el = this.$refs[`${chartItem.type}_${index}`][0];
      el.refresh(componData, { haveOriginData: true });
    });
  }
};
</script>

<style lang="scss" scoped>
.course-report {
  width: 1140px;
  margin: 0 auto;
  color: #2c3443;

  .report-home {
    position: relative;
    .report-home-title {
      color: #001529;
      font-size: 60px;
      line-height: 86px;
      text-align: center;
      padding: 200px 50px 0;
      .course-title {
        font-weight: 600;
      }
      .course-tip {
        font-weight: 600;
      }
    }
    .report-home-footer {
      position: absolute;
      left: 0;
      bottom: 90px;
      width: 100%;
      text-align: center;
      font-size: 33px;
      line-height: 45px;
      .report-home-date {
      }
      .report-home-company {
        margin-top: 20px;
      }
    }
  }

  .report-welcome {
    box-sizing: border-box;
    padding: 62px 50px;
    font-size: 24px;
    color: #2c3443;
    line-height: 45px;

    .welcome-title {
    }

    .welcome-text {
      text-indent: 2em;
    }

    .welcome-right {
      text-align: right;
    }
  }

  .chart-ul {
    box-sizing: border-box;
    padding: 40px;

    .chart-title {
      font-size: 32px;
      line-height: 45px;

      & > span {
        font-weight: 600;
      }
    }

    .chart-li {
      .chart-li-title {
        font-size: 26px;
        line-height: 36px;
        font-weight: 600;
        padding-top: 40px;

        & > span {
          font-weight: 600;
        }
      }
      .chart-item {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid #d2d8e3;
        border-radius: 6px;
        margin-top: 40px;
        padding: 40px;
      }

      .chart-li-tip-content {
        margin-top: 24px;
        .chart-li-tip {
          text-indent: 2em;
          font-size: 24px;
          line-height: 45px;
          color: #2c3443;
        }
      }
    }
  }

  .full-page {
    min-height: 1050px;

    &.first-chart-li {
      min-height: 1020px;
    }

    &.last-chart-li {
      min-height: auto;
    }
  }
}
</style>
